import React from 'react';
import { Document, Page } from 'react-pdf';

interface IPDFDocumentProps {
    fileURL: string;
    onDocumentLoadSuccess: ({ numPages }: { numPages: number }) => void;
    pageNumber: number;
    scale: number;
}

export const PDFDoc: React.FC<IPDFDocumentProps> = ({
    onDocumentLoadSuccess,
    pageNumber,
    fileURL,
    scale,
}) => {
    return (
        <Document file={fileURL} onLoadSuccess={onDocumentLoadSuccess}>
            <Page
                pageNumber={pageNumber}
                scale={scale}
                renderTextLayer={false}
                renderAnnotationLayer={false}
            />
        </Document>
    );
};
